let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4fvmg")).then(() => parcelRequire('eiyt5'));